$(document).ready(function() {
    const $stepBox = $('.step_box');
    const $items = $('.step_item');
    const $upIcon = $('.up_icon');
    const $downIcon = $('.down_icon');
    const itemHeight = $items.first().outerHeight();
    let currentIndex = 0;
    const totalItems = $items.length;
    let autoRotateInterval;

    $stepBox.css({
        'height': itemHeight + 'px',
        'overflow': 'hidden',
        'position': 'relative'
    });
    updateIcons();

    // 初始化自动轮播
    startAutoRotate();

    $upIcon.click(function() {
        clearInterval(autoRotateInterval);
        if (currentIndex > 0) {
            currentIndex--;
            updateCarousel();
        }
        startAutoRotate();
    });

    $downIcon.click(function() {
        clearInterval(autoRotateInterval);
        if (currentIndex < totalItems - 1) {
            currentIndex++;
            updateCarousel();
        }
        startAutoRotate();
    });

    function updateCarousel() {
        $items.removeClass('active').eq(currentIndex).addClass('active');
        $stepBox.animate({
            scrollTop: currentIndex * itemHeight
        }, 300);
        updateIcons();
    }

    function updateIcons() {
        $upIcon.toggleClass('pro_click', currentIndex === 0);
        $downIcon.toggleClass('pro_click', currentIndex === totalItems - 1);
    }

    // 自动轮播函数
    function startAutoRotate() {
        autoRotateInterval = setInterval(function() {
            if (currentIndex < totalItems - 1) {
                currentIndex++;
            } else {
                currentIndex = 0;
            }
            updateCarousel();
        }, 4000);
    }
});

$('.exchange_tab span').click(function () {
    $(this).addClass('active').siblings('span').removeClass('active')
    $('.center_green').removeClass('active').eq($(this).index()).addClass('active')
});